<template lang='pug'>
  bf-flex#auth-layout
    #container
      auth-header(@open='open.left = true' :open='open' @click.native='open.left = false')
      .wrapper.responsive(@click='open.left = false')
        slot
</template>

<script>
  import { View, Animatable } from '@/mixins/view'
  import AuthHeader from '@/components/auth-header'
  export default {
    name: 'auth.layout',

    components: {
      AuthHeader
    },

    data() {
      return {
        open: { left: false }
      }
    },

    created() {
      this.$i18n.locale = localStorage.getItem('locale')
    }
  }

</script>

<style scoped lang="stylus">
  // .drawer-toggle, .link.close, .bf-divider.close
  //   display none !important

  .wrapper
    padding 0 16px
    min-height calc( 100vh - 172px )
    font-size 1.1em

  #auth-layout
    background url('/main.jpg') no-repeat
    background-position center
    background-size cover
    //

  #container
    flex-grow 1
</style>
